import { useSelector } from 'react-redux';
import { useSitemap } from 'wsm-common-data';
import { getCompareLink } from '../utilities/compare';

export const useCompareLink = () => {
	const { compareVehicles } = useSelector((state) => state.compareVehicles);
	const { pageAlias } = useSelector((state) => state.widgetInfo);

	const sitemap = useSitemap();

	const compareLink = getCompareLink({
		sitemap,
		compareVehicles,
		pageAlias
	});

	return compareLink;
};
